
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"682.667","height":"682.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M271 12c-14.8 1.8-28.3 7-39.5 15.3C225.6 31.7 32.6 224.5 27.6 231c-6.2 8.1-9.2 13.7-12.8 24.2-3.1 8.9-3.3 9.9-3.3 24.8s.2 15.9 3.3 25c4.2 12.2 9.7 21.4 18 30.2 10.8 11.4 25.2 19.9 39.9 23.4 9.4 2.3 25.7 2.3 35.8 0 19.4-4.5 35.7 2.8 43.2 19.1 3.4 7.4 3.9 14.9 1.7 25.3-2.3 10.7-2.3 27 0 36.3 5.7 23.9 23.7 45.4 46.4 55.4 18.7 8.2 44.9 8.4 63.7.3 13.4-5.7 14.1-6.4 117.8-109.9 107.4-107.2 108-107.8 114.2-123.5 4.4-11.3 5.7-19.6 5.2-33.1-.8-21.7-8.1-38.2-24.1-54-15.4-15.4-32.7-22.6-54.1-22.8-7.2-.1-13.9.5-19.5 1.7-11.1 2.4-18.2 1.7-26.5-2.3-7.4-3.7-12.7-9.2-16.2-16.8-3.4-7.4-3.9-14.9-1.7-25.3 2.3-10.7 2.3-27 0-36.3-5.7-23.8-22.8-44.3-45.3-54.2-11.8-5.3-29.6-8-42.3-6.5zm-3.6 162c2 1.4 4.9 4.3 6.4 6.4l2.7 3.9v143.3l-2.5 3.7c-4.2 6.3-9.3 9.1-16.9 9.5-8.2.4-13.8-2.2-18.5-8.7l-3.1-4.3V184.2l3-4.3c4.5-6.4 10.4-9.1 18.6-8.7 5 .3 7.5 1 10.3 2.8zM206 224.1c25 11.3 19.2 48.2-8 50.6-22.5 2.1-37.1-23.4-24-41.8 7-9.7 21.3-13.7 32-8.8zm119.5 14.6c3.1 1 6.7 3.4 9.5 6.3 16.1 16 6.2 42.9-16.5 44.8-24.2 1.9-38-27.1-21.2-44.6 7.3-7.7 17.8-10.1 28.2-6.5z"}})])
          )
        }
      }
    